import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";

const FinancialYearForm = (props) => {
  const frmRef = useRef({});

  const { sendRequest: postFinancialYear } = useHttp();

  const [financialYearsData, setFinancialYearsData] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
  const [selectedYearId, setSelectedYearId] = useState("");
  const [update, setUpdate] = useState(false);

  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");


  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const financialYearNameRef = useRef(null);

  const updateFinancialYearName = (start, end) => {
    if (start && end) {
      const startYear = moment(start).format("YY");
      const endYear = moment(end).format("YY");
      const startMonth = moment(start).format("MMM");
      const endMonth = moment(end).format("MMM");
      if (financialYearNameRef.current) {
        financialYearNameRef.current.value = `${startMonth} ${startYear}-${endMonth} ${endYear}`;
      }
    } else {
      if (financialYearNameRef.current) {
        financialYearNameRef.current.value = "";
      }
    }
  };

  const handleStartDateChange = (e) => {
    const value = e.target.value;
    setStartDate(value);
    updateFinancialYearName(value, endDate);
  };

  const handleEndDateChange = (e) => {
    const value = e.target.value;
    setEndDate(value);
    if (moment(value).isSameOrBefore(moment(startDate))) {
      toast.error("End date cannot be less than or equal to start date.");
      setEndDate("");
    } else {
      updateFinancialYearName(startDate, value);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      financialYearName: financialYearNameRef.current.value,
      financialYearStartDate: moment(startDate).format("DD/MM/YYYY"),
      financialYearEndDate: moment(endDate).format("DD/MM/YYYY"),
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId, 
    };

    if (props.update) {
      data["financialYearId"] = props.update.financialYearId;
    }

    postFinancialYear(
      {
        url: "/api/financialYear/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      () => {
        toast.success(
          `Financial Year ${props.update ? "Updated" : "Added"} Successfully`
        );
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      console.log("object", props.update);
      const startDate = props.update.financialYearStartDate.split(" ")[0];
      const [DD, MM, YYYY] = startDate?.split("/");
      const sDate = `${YYYY}-${MM}-${DD}`;
      setStartDate(sDate);

      const endDate = props.update.financialYearEndDate.split(" ")[0];
      const [dd, mm, yyyy] = endDate?.split("/");
      const eDate = `${yyyy}-${mm}-${dd}`;
      setEndDate(eDate);

      if (financialYearNameRef.current) {
        financialYearNameRef.current.value = props.update.financialYearName;
      }
    }
  }, [selectedFinancialYear]);

  
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Financial Year</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Financial Year Start Date</label>
                        <input
                          type="date"
                          id="start-date"
                          className="form-control"
                          value={startDate}
                          onChange={handleStartDateChange}
                          min={minDate}
                          max={maxDate}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Financial Year End Date</label>
                        <input
                          type="date"
                          id="end-date"
                          className="form-control"
                          value={endDate}
                          onChange={handleEndDateChange}
                          min={minDate}
                          max={maxDate}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Financial Year Name</label>
                        <input
                          type="text"
                          id="financialYear"
                          className="form-control"
                          ref={financialYearNameRef}
                          required
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4 text-center">
                      <button
                        className="btn btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default FinancialYearForm;
